import Logger from "@/utility/logger";

export async function readDocumentCustomProperty(key: string): Promise<string | null> {
  if (typeof Word === "undefined" || !Word?.run) return null;
  try {
    return await Word.run(async (context) => {
      const props = context.document.properties.customProperties;
      props.load("items");
      await context.sync();
      const prop = props.items.find((p) => p.key === key);
      if (!prop || !prop.value) return null;
      try {
        const parsed = JSON.parse(prop.value);
        return typeof parsed === "string" ? parsed : String(parsed);
      } catch {
        return prop.value;
      }
    });
  } catch (err) {
    Logger.warn("Failed to read document custom property", key, err);
    return null;
  }
}
